import servicesPhoto from '../images/photos/services.jpg'
import industriesPhoto from '../images/photos/industries.jpg'
import healthcare from '../images/photos/industry-healthcare.jpg'
import architecture from '../images/photos/industry-architecture.jpg'
import fintech from '../images/photos/industry-fintech.jpg'
import ecommerce from '../images/photos/industry-ecommerce.jpg'
import ai from '../images/photos/category-ai.jpg'
import data from '../images/photos/category-data.jpg'
import product from '../images/photos/category-product.jpg'
import strategy from '../images/photos/category-strategy.jpg'

/**
 * Hero photos for the service and industry pages: stock scenes (Unsplash)
 * of each client industry and kind of work, never presented as our team.
 * Sources in src/images/photos/README.md.
 *
 * A page without an entry here falls back to its AbstractVisual.
 */
export const pagePhotos = {
  services: servicesPhoto,
  industries: industriesPhoto,
}

// Keyed by industry slug (data/industries.js)
export const industryPhotos = {
  healthcare,
  'architecture-construction': architecture,
  fintech,
  'ecommerce-retail': ecommerce,
}

// Keyed by service category (data/services.js); every service in a category
// shares the photo
export const serviceCategoryPhotos = { ai, data, product, strategy }
